<template>
    
    <!-- mouse leave -->
    <div v-if="!click" @mouseleave="show = false; scrolls(); $emit('close', true)"  style="position: relative;">
        <div @mouseenter="show = true;scrolls(); $emit('open', true)"><slot name="title"></slot></div> 
        <Transition>
        <div class="container" :style="{marginTop: top}" :class="addclasses"  v-if="show"><slot></slot></div>        
        </Transition>
    </div>    
    <!-- click outside -->
    <div v-else ref="target" style="position: relative;">
        <div @click="show = !show; scrolls(); $emit('open', true)"><slot name="title"></slot></div> 
        <Transition>
        <div class="container" :style="{marginTop: top}" :class="addclasses"  v-if="show"><slot></slot></div>        
        </Transition>
    </div>
</template>

<!-- 
    <MainMenuItem click fixed scroll>
        <template #title>Click</template>
        ...
    </MainMenuItem> 
-->
<script>


export default {
    data: function () {return {
        show: false,
    }},
    
    mounted() {        
        document.addEventListener('click', this.handleClick);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClick);
    },
    methods: {
        handleClick(event) {      
            if (!this.$refs.target.contains(event.target)) this.show = false                
        },
        scrolls(){            
            this.$refs.target.scrollTop = 0            
        }
    },

    props:{        
        top: {type: String, default:"0px"},
        click: Boolean,
        fixed: Boolean,
        center: Boolean,
        scroll: Boolean,
        up: Boolean,
    },    
    computed:{
        addclasses(){
            var list = []
            list.push(this.fixed ? 'fixed' : 'absolute')
            if (this.scroll) list.push('needscroll')
            if (this.up) list.push('up')
            if (this.center) list.push('centerscreen')
            return list
        },
    },
    


}
</script>
<style scoped>
    .container{
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        left: 50%;
        background-color: #212121;
        box-shadow: 0px 100px 80px rgba(0, 0, 0, 0.07), 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
    }
    .fixed{        
        position: fixed;            
        transform: translateX(-50%);        
    }   
    .absolute{
        position: absolute;
        transform: translate(-50%, 0%);        
    }
    .up{        
        top: 50%;
        transform: translate(-50%, -102%);           
    }
    .centerscreen{        
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);           
    }
    
    .needscroll{
        overflow-y: scroll;
    }

.v-enter-active,
.v-leave-active {
  /* transition: opacity 0.5s ease; */
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>